import * as React from "react"
const SvgRedo = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 19q.424 0 .712-.288A.97.97 0 0 0 17 18a.97.97 0 0 0-.288-.712A.97.97 0 0 0 16 17H9.9q-1.575 0-2.738-1Q6 15 6 13.5T7.162 11 9.9 10h6.3l-1.9 1.9a.95.95 0 0 0-.275.7q0 .425.275.7a.95.95 0 0 0 .7.275.95.95 0 0 0 .7-.275l3.6-3.6q.15-.15.212-.325.063-.175.063-.375t-.062-.375A.9.9 0 0 0 19.3 8.3l-3.6-3.6a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7L16.2 8H9.9Q7.475 8 5.737 9.575 4 11.15 4 13.5t1.737 3.925T9.9 19z"
    />
  </svg>
)
export default SvgRedo
